export default {
  common: {
    cancel: 'Annuler',
    remove: 'Supprimer',
    save: 'Valider',
    saving: 'Enregistrement...',
    loading: 'Chargement...',
    km: 'KM',
    m: 'M',
    units: 'unités',
    status: 'Statut',
    nominal: 'Nominal',
    alert: 'Alerte',
    operational: 'Opérationnel',
    time_stamp: 'Horodatage',
    fleet_size: 'Taille_Parc',
    log_v: 'Log_V',
    status_ready: 'STATUT: PRÊT',
  },

  nav: {
    dashboard: 'Dashboard',
    garage: 'Garage',
    add_bike: 'Ajouter un vélo',
    rides: 'Sorties',
    prepare_ride: 'Préparer une Sortie',
    maintenance: 'Maintenance',
    stock: 'Stock',
    logout: 'Déconnexion',
    service: 'Service',
    feedback: 'Feedback',
  },

  header: {
    dashboard: 'Vue Générale',
    garage: 'Vue du Garage',
    add_bike: 'Enregistrer un Vélo',
    bike_detail: 'Détail du Vélo',
    rides: 'Journal des Sorties',
    add_ride: 'Enregistrer une Sortie',
    prepare_ride: 'Analyse GPX',
    maintenance: 'Journal de Maintenance',
    add_maintenance: 'Saisir une Entrée',
    stock: 'Stock Composants',
    profile_settings: 'Profil & Paramètres',
    system_label: 'Système',
    system_optimal: 'Optimal',
    system_degraded: 'Dégradé',
    system_unreachable: '...',
    system_loading: '...',
  },

  confirm: {
    remove_bike_title: 'Supprimer le Vélo',
    remove_bike_msg: 'Ce vélo et toutes ses données seront définitivement supprimés.',
    remove_component_title: 'Supprimer le Composant',
    remove_component_msg: "Ce composant et ses données d'usure seront définitivement supprimés.",
    remove_ride_title: 'Supprimer la Sortie',
    remove_ride_msg: 'Cette sortie sera définitivement supprimée.',
    remove_entry_title: "Supprimer l'Entrée",
    remove_entry_msg: 'Cette entrée de service sera définitivement supprimée.',
    unassign_component_title: 'Envoyer au Stock',
    unassign_component_msg: 'Ce composant sera désassigné du vélo et déplacé dans votre stock.',
    unassign: 'Envoyer au Stock',
    confirm_action: 'Confirmer',
    remove: 'Supprimer',
    cancel: 'Annuler',
  },

  dashboard: {
    loading: 'Chargement du tableau de bord...',
    loading_critical: 'Chargement des alertes...',
    fleet_health: 'Santé du Parc',
    bikes_count: 'Vélos',
    critical_alerts: 'Alertes Critiques',
    in_stock: 'En Stock',
    critical_components: 'Composants Critiques',
    no_critical: 'Aucun composant critique',
    replace_btn: 'Remplacer',
    last_rides: 'Dernières Sorties',
    no_rides: 'Aucune sortie enregistrée',
    last_maintenance: 'Dernières Maintenances',
    no_maintenance: 'Aucune maintenance enregistrée',
    quick_actions: 'Actions Rapides',
    action_add_ride: 'Ajouter une Sortie',
    action_prepare_ride: 'Préparer une Sortie',
    action_prepare_ride_hint: 'GPX · Météo · Tenue',
    action_add_maintenance: 'Logger une Maintenance',
    view_all: 'Voir tout',
    rides_year_title: 'Sorties — Année en cours',
    rides_year_km: 'Distance',
    rides_year_count: 'Sorties',
    rides_year_avg_speed: 'Vitesse Moy.',
    rides_year_elevation: 'Dénivelé',
    rides_year_empty: 'Aucune sortie enregistrée cette année',
    next_planned_rides: 'Prochaines Sorties',
    no_planned_rides: 'Aucune sortie planifiée',
    planned_ride_prepare_cta: 'Planifier une sortie',
  },

  garage: {
    fleet_total: 'Total Parc',
    cumulative_dist: 'Distance Cumulée',
    pending_service: 'Service en Attente',
    alerts: 'Alerte(s)',
    clear: 'OK',
    loading: 'Chargement des vélos...',
    register_bike: 'Enregistrer un Vélo',
    init_config: 'Initialiser la Configuration',
    error_prefix: '',
    remove_bike_title: 'Supprimer le Vélo',
    remove_bike_msg: 'Ce vélo et toutes ses données seront définitivement supprimés.',
    welcome_title: 'BIENVENUE SUR KMZ',
    welcome_subtitle: 'Initialisation // Première Configuration',
    welcome_description: "Gérez vos vélos, suivez l'usure des composants et préparez vos sorties.",
    step1_label: 'Ajouter un Vélo',
    step1_desc: 'Enregistrez votre premier vélo dans le système',
    step2_label: 'Configurer les Composants',
    step2_desc: "Chaîne, pneus, cassette — suivez l'usure",
    step3_label: 'Logger vos Sorties',
    step3_desc: 'Enregistrez vos sorties et maintenances',
    add_first_bike: 'Ajouter mon premier vélo',
  },

  bike_card: {
    service_due: 'Service Requis',
    odometer: 'Odomètre',
    critical: 'Critique',
    since: 'Depuis',
    service_btn: 'Service',
    details_btn: 'Détails',
    remove_btn: 'Supprimer',
    alert_count: '{count} alerte(s)',
  },

  bike_types: {
    road: 'Route',
    gravel: 'Gravel',
    mtb: 'VTT',
    cyclocross: 'Cyclocross',
    city: 'Ville',
  },

  add_bike: {
    title: 'Ajouter un Vélo',
    subtitle: 'Registre Système // Saisie Manuelle Requise',
    field_name: '01_Nom_Vélo',
    field_manufacturer: '02_Fabricant',
    field_model: '03_Modèle',
    field_odometer: '04_Odomètre_Initial',
    field_category: '05_Catégorie',
    field_purchase_date: "06_Date_d'Achat (optionnel)",
    meta_title: "Métadonnées d'Enregistrement",
    meta_v: 'Registre_V',
    warning: 'AVERT : Vérifier toutes les spécifications techniques auprès des manuels fabricant avant soumission.',
    submitting: 'Enregistrement...',
    error: "Échec de l'enregistrement du vélo",
    placeholder_name: 'EX. MON_VELO_01',
    placeholder_brand: 'NOM DE LA MARQUE',
    placeholder_model: 'DÉSIGNATION DU MODÈLE',
    next: 'Suivant',
    back: '← Retour',
    step1_of_2: '01 / 02',
    step2_of_2: '02 / 02',
    step2_subtitle: 'Composants // Quels éléments sont montés sur ce vélo ?',
    step2_brand_placeholder: 'Marque (optionnel)',
    step2_lifespan_label: 'Durée de vie',
    skip_components: 'Créer sans composants',
    component_error: "Vélo créé — certains composants n'ont pas pu être ajoutés.",
    onboarding_banner: "Dernière étape — enregistre ton vélo pour suivre son usure et tes sorties.",
    onboarding_skip: "Passer — accéder au tableau de bord",
    field_strava_gear: '07_Vélo_Strava (optionnel)',
    strava_gear_placeholder: 'Aucun',
    strava_link_title: 'Vélos Strava à associer',
    strava_link_desc: "Ces vélos Strava ne sont pas encore liés à un vélo KMZ. Crée ce vélo et tu seras redirigé pour faire l'association.",
    strava_link_toast: "Vélo créé — associe-le maintenant à un vélo Strava ci-dessous",
  },

  bike_detail: {
    loading: 'Chargement des données vélo...',
    loading_components: 'Chargement des composants...',
    not_found: 'Vélo introuvable',
    back: '← Retour au Garage',
    service_required: 'SERVICE REQUIS',
    system_config: 'Config Système // Profil',
    category: 'Catégorie',
    odometer: 'Odomètre',
    since: 'Depuis',
    components_title: 'Composants',
    active_components: 'Composants Actifs',
    add_component: 'Ajouter',
    register_component: 'Enregistrer un Composant',
    no_components: 'Aucun composant enregistré',
    no_components_hint: 'Ajoutez votre premier composant pour suivre l\'usure',
    type: 'Type',
    brand_opt: 'Marque (optionnel)',
    install_date: "Date d'installation",
    km_at_install: 'KM à l\'installation',
    max_lifespan: 'Durée de vie max (optionnel)',
    km_suffix: 'KM',
    wear: 'Usure',
    installed: 'Installé',
    lifespan: 'Durée de vie',
    remove: 'Supprimer',
    retire: 'Retirer',
    active_badge: 'ACTIF',
    retired_badge: 'RETIRÉ',
    critical_badge: 'CRITIQUE',
    add_error: "Échec de l'enregistrement du composant",
    add_error_conflict: "Un composant '{type}' est déjà actif sur ce vélo. Désinstallez-le d'abord.",
    type_occupied_tooltip: "Déjà installé — désinstallez-le d'abord",
    meta_warning: 'AVERT : Suivez l\'usure des composants pour prévenir les pannes mécaniques.',
    unassign: 'Au Stock',
    replace: 'Remplacer',
    recent_interventions: 'Dernières interventions',
    no_interventions: 'Aucune intervention enregistrée pour ce vélo.',
    view_full_history: 'Voir tout l\'historique →',
    log_intervention: 'Logger une intervention →',
    strava_gear: 'Équipement Strava',
    strava_not_mapped: 'Non associé →',
  },

  replace: {
    btn: 'Remplacer',
    panel_title: 'Remplacement',
    section_intervention: 'A — Intervention',
    section_new_component: 'B — Nouveau Composant',
    field_date: '01_Date',
    field_km: '02_KM Vélo',
    field_cost: '03_Coût',
    field_notes: '04_Notes (optionnel)',
    notes_placeholder: 'Ex. Chaîne usée après 2500km...',
    choice_stock: 'Depuis le Stock',
    choice_new: 'Créer Nouveau',
    choice_none: 'Sans Remplacement',
    select_stock: 'Composant en Stock',
    stock_placeholder: 'SÉLECTIONNER UN COMPOSANT',
    in_stock: 'en stock',
    type_locked: 'type verrouillé',
    submit_btn: 'Confirmer le Remplacement',
    submitting: 'Enregistrement...',
    success_toast: 'Remplacement enregistré avec succès',
    error_submit: "Échec de l'enregistrement du remplacement",
    error_name_required: 'Le nom du composant est requis',
  },

  rides: {
    title: 'Journal des Sorties',
    planned_title: 'Sorties Planifiées',
    completed_title: 'Sorties Réalisées',
    total_rides: 'Total Sorties',
    entries: 'Entrées',
    distance: 'Distance',
    time: 'Temps',
    loading: 'Chargement des sorties...',
    log_ride: 'Enregistrer',
    prepare_ride: 'Préparer une Sortie',
    no_rides: 'Aucune sortie enregistrée',
    no_planned: 'Aucune sortie planifiée',
    first_ride: 'Enregistrez votre première sortie',
    date: 'Date',
    bike: 'Vélo',
    duration: 'Durée',
    avg_speed: 'Vitesse Moy.',
    elevation: 'D+',
    action: 'Action',
    remove: 'Supprimer',
    page_of: 'Page {page} / {total}',
    showing: '{from}–{to} sur {count}',
    prev: 'Préc.',
    next: 'Suiv.',
    bike_ready: 'VÉLO PRÊT',
    bike_needs_maintenance: 'MAINTENANCE REQUISE',
    mark_done: 'Marquer Réalisée',
    marking_done: 'Enregistrement...',
    difficulty: 'Difficulté',
    packing_list: 'Liste de Préparation',
    packing_phone: 'Téléphone',
    packing_tools: 'Chambre à air + CO₂/pompe',
    packing_glasses: 'Lunettes',
    packing_rain_gear: 'Veste pluie / Coupe-vent',
    packing_thermal: 'Sous-couche thermique',
    complete_modal_title: 'Marquer comme réalisée',
    complete_modal_duration: 'Durée réelle',
    complete_modal_duration_hint: 'Laisser à 0h 0m pour conserver la durée estimée ({estimated})',
    complete_modal_confirm: 'Confirmer',
    complete_modal_cancel: 'Annuler',
    complete_error: 'Impossible de marquer la sortie comme réalisée',
    edit: 'Modifier',
    edit_modal_title: 'Modifier la Sortie',
    edit_modal_name: 'Nom',
    edit_modal_date: 'Date',
    edit_modal_duration: 'Durée',
    edit_modal_distance: 'Distance (km)',
    edit_modal_elevation: 'Dénivelé (m)',
    edit_modal_confirm: 'Enregistrer',
    edit_modal_cancel: 'Annuler',
    edit_error: 'Impossible de modifier la sortie',
    name: 'Nom',
    stats_title: 'Analytiques — Résumé & Tendances',
    stats_total_km: 'Distance Totale',
    stats_total_rides: 'Sorties',
    stats_avg_speed: 'Vitesse Moy.',
    stats_total_elevation: 'Dénivelé Cumulé',
    stats_by_bike: 'Par Vélo',
    stats_monthly: 'Tendance Mensuelle',
    stats_filter_year: 'Année',
    stats_filter_bike: 'Vélo',
    stats_all_years: 'Toutes',
    stats_all_bikes: 'Tous',
    stats_export_csv: 'Exporter CSV',
    stats_bike_col: 'Vélo',
    stats_km_col: 'KM',
    stats_rides_col: 'Sorties',
    stats_speed_col: 'Vitesse Moy.',
    stats_elev_col: 'D+',
    stats_loading: 'Chargement des statistiques...',
    avgHr: 'FC moy.',
    avgPower: 'Puissance moy.',
    importRide: 'Importer une sortie',
    importError: "Impossible de lire le fichier. Vérifiez qu'il s'agit d'un fichier .fit ou .gpx valide.",
    importConfirmTitle: 'Données importées',
    importConfirmHint: 'Vous pourrez modifier ces informations sur la page suivante.',
    importConfirm: 'Continuer',
  },

  strava: {
    connected: 'Connecté',
    invalid: 'Token invalide',
    connectDescription: 'Connecte Strava pour importer automatiquement tes activités dans le journal des sorties.',
    connectButton: 'Connecter Strava',
    tokenRevoked: 'Connexion interrompue — Strava a révoqué l\'accès.',
    invalidTokenAction: 'Reconnecter Strava',
    connectionBroken: 'Connexion Strava interrompue',
    goToSettings: 'Paramètres →',
    lastSync: 'Dernière synchronisation',
    gearMappings: 'Association des vélos Strava',
    noGearMappings: 'Aucun vélo Strava détecté.',
    noMapping: 'Non associé',
    gearMappingHint: 'Associe chaque vélo Strava à un vélo KMZ pour que les km s\'accumulent correctement.',
    disconnect: 'Déconnecter Strava',
    redirecting: 'Redirection en cours…',
    connectSuccess: 'Strava connecté avec succès',
    connectError: 'Échec de la connexion Strava ({detail})',
    sync: 'Sync Strava',
    syncing: 'Synchronisation…',
    syncSuccess: '{count} sortie(s) importée(s) depuis Strava',
    syncSuccessZero: 'Aucune nouvelle sortie depuis le {date}.',
    syncErrorDetail: '{count} sortie(s) importée(s), {errors} activité(s) en erreur.',
    syncError: 'Échec de la synchronisation Strava',
    postConnectBanner: 'Strava connecté. Associe tes vélos Strava pour que les km s\'accumulent sur le bon vélo.',
    postConnectBannerCta: 'Configurer →',
    bikeColumn: 'Vélo KMZ',
  },

  prepare_ride: {
    title: 'Préparer une Sortie',
    subtitle: 'Import GPX // Analyse du Parcours',
    step1_title: 'Import & Paramètres',
    field_bike: '01_Vélo',
    field_date: '02_Date_Planifiée',
    field_hour: '03_Heure_Départ',
    field_gpx: '04_Trace_GPX',
    gpx_placeholder: 'SÉLECTIONNER UN FICHIER .GPX',
    analyze_btn: 'Analyser le Parcours',
    analyzing: 'Analyse en cours...',
    step2_title: 'Analyse du Parcours',
    field_name: 'Nom de la Sortie',
    route_card: 'Profil du Parcours',
    weather_card: 'Météo Prévue',
    clothing_card: 'Tenue Recommandée',
    nutrition_card: 'Plan Nutritionnel',
    distance: 'Distance',
    elevation: 'Dénivelé +',
    duration: 'Durée Estimée',
    difficulty: 'Difficulté',
    temperature: 'Température',
    wind: 'Vent',
    precipitation: 'Risque Pluie',
    conditions: 'Conditions',
    calories: 'Calories',
    water: 'Eau',
    gels: 'Gels',
    confirm_btn: 'Planifier cette Sortie',
    restart_btn: '← Nouvelle Analyse',
    confirming: 'Enregistrement...',
    error_bike: 'Veuillez sélectionner un vélo',
    error_gpx: 'Veuillez sélectionner un fichier GPX',
    error_date_range: 'La date doit être comprise entre aujourd\'hui et J+14 (limite de prévision météo)',
    error_analyze: "Impossible d'analyser le fichier GPX",
    error_confirm: "Impossible d'enregistrer la sortie",
    date_hint: 'Prévision disponible sur 14 jours',
    date_out_of_range_warning: 'La prévision météo est disponible jusqu\'au {date_max}. Pour une sortie au-delà, la météo ne sera pas disponible.',
    difficulty_easy: 'Facile',
    difficulty_moderate: 'Modéré',
    difficulty_hard: 'Difficile',
    difficulty_very_hard: 'Très Difficile',
    weather_clear: 'Dégagé',
    weather_partly_cloudy: 'Partiellement Nuageux',
    weather_fog: 'Brouillard',
    weather_rain: 'Pluie',
    weather_snow: 'Neige',
    weather_showers: 'Averses',
    weather_storm: 'Orage',
    speed_note: 'Durée estimée à {speed} km/h (votre moy.)',
    weather_timeline_title: 'Météo Heure par Heure',
    weather_timeline_empty: 'Aucune donnée horaire disponible',
    map_title: 'Carte du Parcours',
    elevation_title: 'Profil Altimétrique',
    climbs_title: 'Cols Détectés',
    climb_category: 'Cat.',
    wind_title: 'Impact du Vent',
    wind_headwind: 'Vent de face',
    wind_tailwind: 'Vent arrière',
    wind_crosswind: 'Vent latéral',
    wind_penalty: 'Pénalité Vent',
    wind_critical_zones: 'Zones critiques',
    component_alerts_title: 'Alertes Composants',
    component_alerts_empty: 'Aucun composant critique pour cette sortie',
    no_alerts: 'Tout est OK',
    nutrition_bars: 'Barres',
    nutrition_electrolytes: 'Électrolytes',
    nutrition_advice: 'Conseil',
    difficulty_score: 'Score',
    difficulty_factors: 'Facteurs',
    factor_distance: 'Distance',
    factor_elevation: 'Dénivelé',
    factor_gradient: 'Pente',
  },

  clothing: {
    feels_like: 'Ressenti',
    layer_base: 'Sous-couche',
    layer_mid: 'Couche intermédiaire',
    layer_outer: 'Couche extérieure',
    layer_accessories: 'Accessoires',
    layer_rain: 'Protection Pluie',
    layer_uv: 'Protection UV',
    items_short: 'pcs',
  },

  add_ride: {
    title: 'Enregistrer une Sortie',
    subtitle: 'Journal Activité // Saisie Manuelle Requise',
    field_name: '00_Nom (optionnel)',
    field_bike: '01_Vélo',
    field_date: '02_Date',
    field_distance: '03_Distance',
    field_elevation: '04_Dénivelé (m, optionnel)',
    meta_title: "Métadonnées d'Activité",
    note: "NOTE : Les données d'activité sont utilisées pour suivre l'usure des composants. Assurez-vous que la distance est précise.",
    submitting: 'Enregistrement...',
    error_bike: 'Veuillez sélectionner un vélo',
    error_duration: 'La durée doit être supérieure à 0',
    error_distance: 'La distance doit être supérieure à 0',
    error_submit: "Échec de l'enregistrement de la sortie",
    select_bike: 'SÉLECTIONNER UN VÉLO',
  },

  maintenance: {
    title: 'Journal de Maintenance',
    total_entries: 'Total Entrées',
    logs: 'Logs',
    cost_ytd: 'Coût Annuel',
    replacements: 'Remplacements',
    parts: 'Pièces',
    loading: 'Chargement...',
    all_bikes: 'Tous les Vélos',
    all_actions: 'Toutes Actions',
    export_csv: 'Exporter CSV',
    log_service: 'Saisir Service',
    no_entries: 'Aucune entrée de maintenance',
    first_service: 'Saisissez votre premier service',
    date: 'Date',
    bike: 'Vélo',
    component: 'Composant',
    action: 'Action',
    notes: 'Notes',
    cost: 'Coût',
    km_at_change: 'KM Vélo',
    remove: 'Supprimer',
    entry_singular: 'entrée',
    entry_plural: 'entrées',
    total_cost: 'coût total',
    page_of: 'Page {page} / {total}',
    showing: '{from}–{to} sur {count}',
    prev: 'Préc.',
    next: 'Suiv.',
    actions: {
      cleaned: 'NETTOYÉ',
      replaced: 'REMPLACÉ',
      adjusted: 'AJUSTÉ',
      updated: 'MIS À JOUR',
      inspected: 'INSPECTÉ',
    },
    tab_log: 'Journal',
  },

  add_maintenance: {
    title: 'Saisir une Entrée de Service',
    subtitle: 'Journal Maintenance // Saisie Manuelle Requise',
    field_bike: '01_Vélo',
    field_date: '02_Date',
    field_action: '03_Action',
    field_component: '04_Composant(s)',
    field_km_at_change: '05_KM Vélo au changement',
    field_cost: '06_Coût',
    field_notes: '07_Notes',
    meta_title: 'Métadonnées de Service',
    meta_component: 'cible(s) sélectionnée(s)',
    select_bike: 'SÉLECTIONNER UN VÉLO',
    select_component: 'SÉLECTIONNER LE VÉLO OU DES COMPOSANTS',
    loading_components: 'Chargement composants...',
    no_components: 'Aucun composant actif sur ce vélo',
    select_bike_first: "Sélectionnez d'abord un vélo",
    bike_target: 'VÉLO — Entretien global',
    km_placeholder: 'KM actuels du vélo',
    note: 'NOTE : Sélectionnez le vélo pour un entretien global, ou des composants spécifiques pour un suivi d\'usure précis.',
    submitting: 'Enregistrement...',
    error_bike: 'Veuillez sélectionner un vélo',
    error_target: 'Sélectionnez au moins un composant ou le vélo',
    error_replace_one: 'Pour un remplacement, sélectionnez exactement un composant (pas le vélo)',
    error_submit: "Échec de l'enregistrement",
    replace_side_effect_note: "NOTE : L'action 'Remplacé' avec un composant lié renverra automatiquement l'ancien composant au stock.",
  },

  component_types: {
    chain: 'Chaîne',
    cassette: 'Cassette',
    front_tire: 'Pneu Avant',
    rear_tire: 'Pneu Arrière',
    front_wheel: 'Roue Avant',
    rear_wheel: 'Roue Arrière',
    front_disc: 'Disque Avant',
    rear_disc: 'Disque Arrière',
    front_brake_pad: 'Plaquette Avant',
    rear_brake_pad: 'Plaquette Arrière',
    front_derailleur: 'Dérailleur Avant',
    rear_derailleur: 'Dérailleur Arrière',
    crankset: 'Pédalier',
    handlebar: 'Guidon',
    saddle: 'Selle',
    other: 'Autre',
  },

  auth: {
    field_email: '01_Email',
    field_password: '02_Mot_de_passe',
    field_first_name: '01_Prénom',
    field_last_name: '02_Nom',
    field_password_register: '04_Mot_de_passe',
    field_error_first_name_required: 'Le prénom est obligatoire',
    field_error_email_format: 'Adresse email invalide',
    field_error_password_min: 'Mot de passe : 8 caractères minimum',
    authenticate: 'Se connecter',
    authenticating: 'Connexion...',
    register_link: 'Créer un compte →',
    login_error: 'Email ou mot de passe incorrect',
    create_account: 'Créer le compte',
    creating_account: 'Création en cours...',
    initialize_account: 'Initialiser le compte',
    back_to_login: '← Retour à la connexion',
    register_error: "Échec de l'inscription",
    error_email_taken: 'Cet email est déjà utilisé. Essayez de vous connecter.',
    error_weak_password: 'Mot de passe trop faible (6 caractères minimum).',
    error_email_invalid: "L'adresse email n'est pas valide.",
    error_rate_limited: 'Trop de tentatives. Patientez quelques minutes avant de réessayer.',
    error_network: 'Connexion impossible. Vérifiez votre réseau.',
    error_generic: "Échec de l'inscription. Réessayez plus tard.",
    error_link_expired: 'Lien de confirmation expiré ou invalide.',
    error_profile_missing: 'La création de ton profil a échoué. Réessaie de te connecter.',
    resend_email: "Renvoyer l'email",
    resend_cooldown: 'Renvoyer ({n}s)',
    resend_sent: 'Email renvoyé',
    resend_error: "Impossible de renvoyer l'email",
    change_email: "Modifier l'adresse",
    restart_signup: "Recommencer l'inscription",
    forgot_password_link: 'Mot de passe oublié ?',
    forgot_password_title: 'Réinitialiser le mot de passe',
    forgot_password_subtitle: 'Entrez votre email pour recevoir un lien de réinitialisation',
    forgot_password_submit: 'Envoyer le lien',
    forgot_password_submitting: 'Envoi...',
    forgot_password_sent_title: 'Lien envoyé',
    forgot_password_sent_body: "Vérifiez votre boîte mail. Un lien de réinitialisation a été envoyé à",
    forgot_password_hint: "Vous ne le recevez pas ? Vérifiez vos spams.",
    reset_password_title: 'Nouveau mot de passe',
    reset_password_field_new: '01_Nouveau mot de passe',
    reset_password_field_confirm: '02_Confirmation',
    reset_password_submit: 'Définir le mot de passe',
    reset_password_submitting: 'Enregistrement...',
    reset_password_success: 'Mot de passe mis à jour. Vous pouvez maintenant vous connecter.',
    reset_password_error_mismatch: 'Les mots de passe ne correspondent pas',
    reset_password_error: 'Échec de la réinitialisation. Le lien est peut-être expiré.',
    placeholder_first_name: 'PRÉNOM',
    placeholder_last_name: 'NOM',
    placeholder_email: 'operateur@domaine.com',
    placeholder_password: 'min. 8 caractères',
    mission_status_title: 'STATUT MISSION',
    confirmation_sent_title: 'Vérifiez votre boîte mail',
    confirmation_hint: "Pas reçu ? Vérifiez vos spams. Confirmez votre email puis revenez vous connecter.",
    mission_account_init: 'Compte initialisé',
    mission_email_sent: 'Email de confirmation envoyé',
    mission_email_verify: 'Email vérifié',
    mission_garage_unlock: 'Garage débloqué',
    mission_pending: 'EN ATTENTE',
    mission_locked: 'VERROUILLÉ',
    mfa_challenge_title: 'Authentification à deux facteurs',
    mfa_challenge_subtitle: "Entrez le code à 6 chiffres de votre application d'authentification",
    mfa_code_label: "01_Code d'authentification",
    mfa_code_placeholder: '000000',
    mfa_verify: 'Vérifier',
    mfa_verifying: 'Vérification...',
    mfa_error_invalid: 'Code invalide. Réessayez.',
    mfa_error: 'Échec de la vérification',
    callback_processing: 'Authentification en cours...',
  },

  component: {
    edit_title: 'Modifier le Composant',
    edit_btn: 'Modifier',
    edit_success: 'Composant mis à jour',
    edit_error: 'Échec de la mise à jour du composant',
    accumulated_km: 'KM Accumulés',
  },

  stock: {
    title: 'Stock Composants',
    subtitle: 'Inventaire // Composants Non Assignés',
    total: 'En Stock',
    components: 'Composants',
    accumulated_km: 'KM Accumulés',
    loading: 'Chargement du stock...',
    no_components: 'Aucun composant en stock',
    no_components_hint: 'Désinstallez un composant depuis un vélo pour le retrouver ici.',
    add_btn: 'Ajouter au Stock',
    assign_btn: 'Monter',
    remove_btn: 'Supprimer',
    assign_title: 'Monter sur un Vélo',
    assign_select_placeholder: 'SÉLECTIONNER UN VÉLO',
    assign_confirm: 'Monter',
    assign_confirm_loading: 'Montage...',
    assign_cancel: 'Annuler',
    field_name: '01_Nom',
    field_type: '02_Type',
    field_brand: '03_Marque',
    error_brand_required: 'La marque est requise. Choisissez une marque ou sélectionnez « Autre ».',
    field_date: '04_Date',
    field_initial_km: '05_KM Initiaux',
    field_lifespan: '06_Durée de Vie Max (optionnel)',
    field_price: '07_Prix d\'Achat (optionnel)',
    submitting: 'Enregistrement...',
    error_submit: "Échec de l'ajout du composant au stock",
    error_assign_conflict: "Un composant de ce type est déjà monté sur ce vélo. Démontez-le d'abord via la fiche du vélo.",
    meta_title: 'Métadonnées Stock',
    note: "NOTE : Les composants en stock n'accumulent pas d'usure. L'usure est suivie uniquement lorsqu'ils sont montés sur un vélo.",
    status_ready: 'STATUT : INVENTAIRE_PRÊT',
  },

  profile: {
    title: 'Profil & Paramètres',
    subtitle: 'Compte // Gestion du Profil',
    section_profile: 'Mon Profil',
    section_security: 'Sécurité',
    section_mfa: 'Authentification à deux facteurs (2FA)',
    section_stats: 'Statistiques de Sortie',
    section_danger: 'Zone Danger',
    stat_rides: 'Sorties',
    stat_distance: 'Distance Totale',
    stat_elevation: 'Dénivelé Total',
    stat_duration: 'Durée Totale',
    stat_avg_speed: 'Vitesse Moyenne',
    stat_fallback_note: 'Pas assez de données — vitesse par défaut 20 km/h utilisée pour la préparation',
    field_first_name: '01_Prénom',
    field_last_name: '02_Nom',
    field_email: '03_Email',
    field_weight: '04_Poids',
    field_weight_placeholder: 'Ex. 72',
    field_weight_hint: 'Optionnel — utilisé pour estimer les calories en préparation de sortie',
    field_height: '05_Taille (cm)',
    field_height_placeholder: 'Ex. 178',
    field_dob: '06_Date de naissance',
    field_gender: '07_Genre',
    field_ftp: '08_FTP (watts)',
    field_ftp_placeholder: 'Ex. 250',
    field_ftp_hint: 'Optionnel — utilisé pour personnaliser la difficulté et la nutrition',
    field_bpm_max: '09_FCmax (bpm)',
    field_bpm_max_placeholder: 'Ex. 190',
    field_bpm_max_hint: 'Optionnel — utilisé pour les zones d’entraînement',
    field_current_password: '01_Mot de Passe Actuel',
    field_new_password: '02_Nouveau Mot de Passe',
    field_confirm_password: '03_Confirmation',
    field_delete_confirm: 'Tapez DELETE pour confirmer',
    save_profile: 'Enregistrer le Profil',
    save_password: 'Changer le Mot de Passe',
    delete_account_btn: 'Supprimer mon Compte',
    profile_saved: 'Profil mis à jour',
    password_saved: 'Mot de passe modifié',
    danger_warning: "ATTENTION : La suppression du compte est irréversible. Toutes vos données (garage, vélos, composants, sorties, maintenance) seront définitivement supprimées.",
    error_email_conflict: 'Cet email est déjà utilisé par un autre compte',
    error_save: "Échec de l'enregistrement",
    error_wrong_current: 'Mot de passe actuel incorrect',
    error_password_mismatch: 'Les mots de passe ne correspondent pas',
    error_delete_confirm: 'Tapez exactement DELETE pour confirmer',
    error_delete: 'Échec de la suppression du compte',
    mfa_status_disabled: '2FA actuellement désactivée',
    mfa_status_enabled: '2FA actuellement activée',
    mfa_enable_btn: 'Activer la 2FA',
    mfa_disable_btn: 'Désactiver la 2FA',
    mfa_disabling: 'Désactivation...',
    mfa_enroll_title: 'Scanner le QR Code',
    mfa_enroll_body: "Scannez ce QR code avec votre application d'authentification (Google Authenticator, Authy, 1Password…)",
    mfa_secret_label: 'Clé de saisie manuelle',
    mfa_verify_title: 'Confirmer la configuration',
    mfa_verify_body: "Entrez le code à 6 chiffres de votre application pour confirmer",
    mfa_code_label: "01_Code d'authentification",
    mfa_confirm_btn: 'Confirmer',
    mfa_confirming: 'Vérification...',
    mfa_enabled_toast: '2FA activée',
    mfa_disabled_toast: '2FA désactivée',
    mfa_error: 'Échec de la mise à jour de la 2FA',
    mfa_error_invalid: 'Code invalide. Réessayez.',
  },

  feedback: {
    title: 'Feedback & Support',
    subtitle: 'Retour Utilisateur // Signalement & Suggestions',
    category_label: 'Catégorie',
    category_bug: 'Problème',
    category_support: 'Support',
    category_suggestion: 'Suggestion',
    category_other: 'Autre',
    field_subject: '01_Sujet',
    field_message: '02_Message',
    subject_placeholder: 'Décrivez brièvement votre retour...',
    message_placeholder: 'Donnez-nous tous les détails utiles...',
    char_count: '{count} / 3000',
    submit: 'Envoyer',
    submitting: 'Envoi...',
    cancel: 'Annuler',
    success_toast: 'Merci pour votre retour !',
    error_toast: "Impossible d'envoyer le feedback. Réessayez.",
    min_length_hint: '10 caractères minimum',
  },

  onboarding: {
    profile_title: 'Profil cycliste',
    profile_subtitle: "Renseigne tes paramètres physiologiques pour personnaliser tes recommandations de sortie. Tout est optionnel — tu pourras les compléter plus tard.",
    section_body: 'Mensurations',
    section_performance: 'Performance',
    gender_male: 'Homme',
    gender_female: 'Femme',
    gender_other: 'Autre',
    gender_prefer_not_to_say: 'Préfère ne pas répondre',
    gender_placeholder: 'Sélectionner',
    save_and_continue: 'Enregistrer et continuer',
    save_loading: 'Enregistrement...',
    skip_for_now: 'Plus tard',
    saved_toast: 'Profil enregistré',
    skipped_toast: 'Tu pourras compléter ton profil dans les paramètres',
    error_save: "Échec de l'enregistrement du profil",
    error_age_range: "L'âge doit être compris entre 10 et 120 ans",
    error_dob_future: 'La date de naissance doit être passée',
    error_ftp_range: 'La FTP doit être comprise entre 50 et 2000 watts',
    error_bpm_range: 'La FCmax doit être comprise entre 100 et 250 bpm',
    error_height_range: 'La taille doit être comprise entre 100 et 250 cm',
    error_weight_range: 'Le poids doit être compris entre 1 et 300 kg',
    strava_section_title: 'Strava (optionnel)',
    strava_section_desc: 'Connecte Strava pour pré-remplir automatiquement poids, FTP et genre — et pour synchroniser tes vélos et importer tes sorties passées dans le journal.',
    strava_prefilled_notice: 'Profil pré-rempli depuis Strava — vérifie et ajuste si besoin.',
    strava_already_connected: 'Strava connecté — profil et vélos synchronisés.',
  },
}
